/**
 * @Description:
 * @author WZP
 * @date 2021/8/25
 */

import React from 'react';
import classNames from 'classnames/bind';

import styles from './styles.scss';
import PageContainer from 'containers/en/page-container';
import { useTranslation } from 'hooks/use-translation';

const cx = classNames.bind(styles);

const LogoImg = 'https://web-data.zmlearn.com/image/aaGEf6tohVwFEPqQBdcxMt/logo%402x.png';
const ImageBanner = 'https://web-data.zmlearn.com/image/3fg1m6wfe899YHfb2uxMMQ/pmg%EF%BC%8Fcomputer%402x.png';
const IconApple = 'https://web-data.zmlearn.com/image/rh1ji2GnxZ5aj8nbXqpdwb/pingguo-2%202%402x.png';
const IconWindows = 'https://web-data.zmlearn.com/image/2JdyFJRPvSM8UCetvFMpSB/windows-2%202%402x.png';
const IconMac = 'https://web-data.zmlearn.com/image/kd4rwWXf3ZVRR4Ai9Z7nW2/macOS%202%402x.png';
const TeacherImg = 'https://web-data.zmlearn.com/image/kmU7CakXMoL8XSQGqpkzov/launchlogo_teacher%402x.png';
const StudentImg = 'https://web-data.zmlearn.com/image/k1SL337fNP9rBq93FXMgKb/launchlogo_student%402x.png';
const IconDownload = 'https://web-data.zmlearn.com/image/xphqXCnX93M1CVfw14LJWz/icon_Download%402x.png';
const IconGooglePlay = 'https://web-data.zmlearn.com/image/vHgf52Ti2HiVEF764JACMB/Google%20play%402x.png';
const IconAndorid = 'https://web-data.zmlearn.com/image/8QejGEFHChzB9EaT67TboN/anzhuo-2%202%402x.png';
const IconNext = 'https://web-data.zmlearn.com/image/3oyJuG5nDxT1zqTHSfhs4A/icon_next%402x.png';
const AppLink = {
	// 下载地址
	winTeacher: 'https://web-data.zmlearn.com/client/7qRA2X8nMAuN5QQTtgjbjo/AirClass%20Teacher%20Setup%201.1.8.exe',
	macTeacher: 'https://web-data.zmlearn.com/client/k8oAKs92yurokPpeAjPC12/AirClass%20Teacher-1.1.5.dmg',
	winStudent: 'https://web-data.zmlearn.com/client/bRaS3QqM6iCDAf8tfCSsrw/AirClass%20Student%20Setup%201.1.7.exe',
	macStudent: 'https://web-data.zmlearn.com/client/fFjPpLPhwegNxCXhGt2Bi/AirClass%20Student-1.1.7.dmg',
	// 安卓apk安装包地址
	apkStudent: 'https://a-app-gateway.air-class.com/air-student-api/app/download/apk',
	// 二维码
	androidStudent:
		// 'https://web-data.zmlearn.com/image/k1jvwA4XcMfa4jhWpQLV5A/%E4%BA%8C%E7%BB%B4%E7%A0%81%E5%9B%BE%E7%89%87_9%E6%9C%881%E6%97%A510%E6%97%B659%E5%88%8645%E7%A7%92.png',
		'https://web-data.zmlearn.com/image/bSGQhfWZMJeHGvwTDa5hLf/ACenQRCODE.png',
	iphoneStudent:
		'https://web-data.zmlearn.com/image/9mituCdXU6YdfP1sibcbfa/%E4%BA%8C%E7%BB%B4%E7%A0%81%E5%9B%BE%E7%89%87_9%E6%9C%882%E6%97%A515%E6%97%B641%E5%88%8637%E7%A7%92.png',
	// 应用商店
	androidStoreStudent: 'https://play.google.com/store/apps/details?id=com.zhangmen.airclass',
	// androidAppDownloadUrl: 'https://web-data.zmlearn.com/doc/tGNdLMThrYLSfjgnus17Lt/airclass_v2.8.0_online_2023_09_26_18_03_release.apk',
	androidAppDownloadUrl: 'https://s.air-class.com/HDR6HB',
	iphoneStoreStudent: 'itms-apps://itunes.apple.com/app/id1581228307',
};

function Download(props: Record<string, any>) {
	const { transData } = useTranslation('download');
	const {
		forStudent,
		windows,
		mac,
		iphone,
		android,
		download,
		scan,
		scan1,
		toDownload,
		newToDownload,
		scanA,
		or,
		clickHere,
		h2,
		p,
		span1,
		ios,
		play,
		newPlay,
		play1,
		windowsTitle,
		macTitle,
		forTeacher,
		guide,
		pdf_url,
	} = transData;
	return (
		<PageContainer>
			<div className={cx('layout')}>
				<div className={cx('download-wrap')}>
					<div className={cx('box-title')}>
						<span className={cx('icon')}>
							<img loading="lazy" src={StudentImg} alt="" />
						</span>
						<span className={cx('title')}>{forStudent}</span>
					</div>
					<div className={cx('box-wrap')}>
						<div className={cx('border-box')}>
							<img loading="lazy" className={cx('icon')} src={IconWindows} alt="" />
							<p>{windows}</p>
						</div>
						<a href={AppLink.winStudent}>{download}</a>
					</div>

					<div className={cx('box-wrap')}>
						<div className={cx('border-box')}>
							<img loading="lazy" className={cx('icon')} src={IconMac} alt="" />
							<p>{mac}</p>
						</div>
						<a href={AppLink.macStudent}>{download}</a>
					</div>

					<div className={cx('box-wrap')}>
						<div className={cx('border-box', 'scan')}>
							<img loading="lazy" className={cx('icon')} src={IconApple} alt="" />
							<p>{iphone}</p>

							<div className={cx('qrcode-wrap')}>
								<div>
									<img loading="lazy" src={AppLink.iphoneStudent} alt="" />
								</div>
								<p>{scan}</p>
							</div>
						</div>
						<p className={cx('desc')}>
							<span>{scan1}</span>
							<span>{toDownload}</span>
						</p>
					</div>

					<div className={cx('box-wrap')}>
						<div className={cx('border-box', 'scan')}>
							<img loading="lazy" className={cx('icon')} src={IconAndorid} alt="" />
							<p>{android}</p>

							<div className={cx('qrcode-wrap')}>
								<div>
									<img loading="lazy" src={AppLink.androidStudent} alt="" />
								</div>
								<p>{scanA}</p>
							</div>
						</div>
						<p className={cx('desc')}>
							<span>
								{scan1}
								{/* {or} */}
							</span>
							<span>
								{/* <a className={cx('apk-btn')} href={AppLink.apkStudent}>{clickHere}</a> */}
								{toDownload}
							</span>
						</p>
					</div>

					<div className={cx('box-pdf')}>
						<span className={cx('icon')}>
							<img loading="lazy" src={'https://web-data.zmlearn.com/image/4TTmKJjY2FGLjcA3q5pjzS/icon_PDF%402x.png'} alt="" />
						</span>
						<span className={cx('title')}>
							<a target="__blank" href={pdf_url}>
								{guide}
							</a>
						</span>
					</div>
				</div>

				<div className={cx('banner-wrap')}>
					<div className={cx('green-circular')} />
					<div className={cx('blue-circular')} />

					<div className={cx('content')}>
						<img loading="lazy" src={ImageBanner} alt="" />

						<div className={cx('content-right')}>
							<div className={cx('logo-wrap')}>
								<img className={cx('logo')} src={LogoImg} alt="" />
							</div>
							<h2>{h2}</h2>
							<p>{p} </p>
						</div>
					</div>
				</div>

				<div className={cx('download-wrap', 'mobile')}>
					<div className={cx('box-wrap')}>
						<a href={AppLink.iphoneStoreStudent} className={cx('border-box')}>
							<img loading="lazy" className={cx('icon')} src={IconApple} alt="" />
							<p>
								{ios} <img className={cx('next')} src={IconNext} alt="" loading="lazy" />
							</p>
						</a>
						<p className={cx('desc')}>
							<span>{span1}</span>
							<span>{toDownload}</span>
						</p>
					</div>

					<div className={cx('box-wrap')}>
						<a href={AppLink.androidAppDownloadUrl} className={cx('border-box')}>
							<img loading="lazy" className={cx('icon')} src={IconAndorid} alt="" />
							<p>
								{play1}
								<img className={cx('next')} src={IconNext} alt="" loading="lazy" />
							</p>
						</a>
						<p className={cx('desc')}>
							<span>
								{newPlay}
								{/* {or} */}
							</span>
							<span>
								{/* <a className={cx('apk-btn')} href={AppLink.apkStudent}>Click here</a> */}
								<span>{newToDownload}</span>
							</span>
						</p>
					</div>

					<div className={cx('box-pdf')}>
						<span className={cx('icon')}>
							<img loading="lazy" src={'https://web-data.zmlearn.com/image/4TTmKJjY2FGLjcA3q5pjzS/icon_PDF%402x.png'} alt="" />
						</span>
						<span className={cx('title')}>
							<a target="__blank" href={pdf_url}>
								{guide}
							</a>
						</span>
					</div>
				</div>
				<div className={cx('download-wrap', 'teacher')}>
					<div className={cx('box-title')}>
						<span className={cx('icon')}>
							<img loading="lazy" src={TeacherImg} alt="" />
						</span>
						<span className={cx('title')}>{forTeacher}</span>
					</div>
					<a className={cx('item-box')} href={AppLink.winTeacher}>
						<img loading="lazy" className={cx('icon')} src={IconWindows} alt="" />
						<span>{windowsTitle}</span>
						<img className={cx('icon-d')} src={IconDownload} alt="" loading="lazy" />
					</a>

					<a className={cx('item-box')} href={AppLink.macTeacher}>
						<img loading="lazy" className={cx('icon')} src={IconMac} alt="" />
						<span>{macTitle}</span>
						<img className={cx('icon-d')} src={IconDownload} alt="" loading="lazy" />
					</a>
				</div>
			</div>
		</PageContainer>
	);
}

export default Download;
